import template from './searchLoanProducts.template.html';
import templateSearchWarning from '../lender/searchWarning.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    lenders: '<',
    documents: '<',
    expenses: '<',
    homeLoanSecurities: '<',
    reviewProducts: '<',
    compareProducts: '<',
    chosenProducts: '<',
    fundingWorksheets: '<',
    searchFields: '<',
    maximumBorrowing: '<',
    idTicket: '<',
    isSplitSearch: '<',
    isTicketSettled: '<',
    onShow: '&',
    onSelected: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdMedia,
      $mdDialog,
      eventService,
      changesService,
      helperService,
      financeService,
      financesService,
      homeLoanService,
      productsService,
      TransactionType,
      HomeLoanSearchProduct,
      Product
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableTermInYears = [];
      ctrl.availableTermYearsOrMonths = [];
      ctrl.availableRepaymentTypes = [];
      ctrl.availableRateTypes = [];
      ctrl.availableLoanTypes = [];
      ctrl.availablePropertyUse = [];
      ctrl.availableYesNoTypes = [];
      ctrl.availableOffset = [];
      ctrl.availableProducts = [];
      ctrl.searchProductParams = {};
      ctrl.products = [];
      ctrl.showSearch = true;
      ctrl.showSearchResult = false;
      ctrl.searchStarted = false;
      ctrl.isLoadingFinished = false;
      ctrl.isProcessing = false;
      ctrl.canSearch = true;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().cca2;
        ctrl.availableTermInYears = helperService.getAvailableTermInYears({ isRegular: false });
        ctrl.availableTermYearsOrMonths =
          ctrl.organizationCountry !== 'NZ'
            ? helperService.getAvailableTermInYears({ isRegular: false })
            : helperService.getAvailableTermInYearsShownInMonths({ isRegular: true });
        ctrl.availableRepaymentTypes = homeLoanService.getAvailableRepaymentTypes();
        ctrl.availableRateTypes = homeLoanService.getAvailableRateTypes();
        ctrl.availableLoanTypes = homeLoanService.getAvailableLoanTypes();
        ctrl.availablePropertyUse = homeLoanService.getAvailablePropertyUse();
        ctrl.availableYesNoTypes = homeLoanService.getYesNoTypes();
        ctrl.availableOffset = homeLoanService.getAvailableOffset();
        ctrl.lenders = _.chain(ctrl.lenders).sortNatural('name').value();
        ctrl.documents = ctrl.documents || [];
        ctrl.expenses = _.filter(ctrl.expenses || [], (e) => e?.id && _.isUuid(e?.id));
        ctrl.homeLoanSecurities = ctrl.homeLoanSecurities || [];
        ctrl.reviewProducts = ctrl.reviewProducts || [];
        ctrl.compareProducts = ctrl.compareProducts || [];
        ctrl.chosenProducts = ctrl.chosenProducts || [];
        ctrl.fundingWorksheets = ctrl.fundingWorksheets || {};
        ctrl.searchFields = ctrl.searchFields || {};
        ctrl.maximumBorrowing = ctrl.maximumBorrowing || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isSplitSearch = ctrl.isSplitSearch || false;
        ctrl.isQuickTool = !ctrl.idTicket || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.limitTo = ctrl.organizationCountry !== 'NZ' ? 11 : 21;
        if (ctrl.reviewProducts?.length > 4 || ctrl.chosenProducts?.length > 4) {
          const pLen = ctrl.reviewProducts?.length || 0;
          ctrl.reviewProducts = ctrl.reviewProducts.splice(pLen - 4, pLen - 1);
          ctrl.compareProducts = ctrl.compareProducts.splice(pLen - 4, pLen - 1);
          ctrl.chosenProducts = ctrl.chosenProducts.splice(pLen - 4, pLen - 1);
          ctrl.saveSearchLoanProducts();
        } else if (
          (ctrl.reviewProducts?.length <= 4 || ctrl.chosenProducts?.length <= 4) &&
          !ctrl.isTicketSettled
        ) {
          ctrl.getSetSearch();
        }
        ctrl.isReady = true;
      };

      ctrl.getSetSearch = () => {
        let needsToSave = false;
        if (ctrl.reviewProducts?.length && !ctrl.chosenProducts.length) {
          for (let c = 0; c < ctrl.reviewProducts.length; c += 1) {
            ctrl.chosenProducts.push(
              Product.Build(ctrl.reviewProducts[c]?.productSplits[0]?.selectedProduct)
            );
          }
        }
        if (ctrl.searchFields?.isNew) {
          let loanAmount = 0;
          let lvr = 0;
          if (!_.isEmpty(ctrl.fundingWorksheets)) {
            const balanceAmount = _.reduce(
              _.filter(
                ctrl.fundingWorksheets.fundsRequired,
                (f) =>
                  f?.transactionType?.name === TransactionType.top_up_or_increase.name ||
                  f?.transactionType?.name === TransactionType.equity_release.name
              ),
              (memo, num) => memo + helperService.isNumber(num.existingLoanBalance, true),
              0
            );
            const proposedLoanAmount = _.reduce(
              ctrl.fundingWorksheets.fundsAvailable,
              (memo, num) => memo + helperService.isNumber(num.proposedLoanAmount, true),
              0
            );
            loanAmount = balanceAmount + proposedLoanAmount;
            const maxLVR = _.max(_.map(ctrl.fundingWorksheets.fundsAvailable, 'baseLvr'));
            lvr = Math.round(maxLVR * 1e2) / 1e2 || 0;
          }

          ctrl.searchFields.idLenders = ctrl.searchFields?.idLenders?.length
            ? ctrl.searchFields.idLenders
            : [];
          ctrl.searchFields.type = 'RESIDENTIAL';
          ctrl.searchFields.loanAmount = loanAmount || 0;
          ctrl.searchFields.lvr = lvr || 0;
          ctrl.searchFields.loanTerm = 30;
          ctrl.searchFields.isNew = false;
          needsToSave = true;
        }
        if (needsToSave) {
          ctrl.searchProductChanges();
        }
      };

      ctrl.changeSearchParams = () => {
        ctrl.availableProducts = [];
      };

      ctrl.searchStart = ({ isSearchStarted }) => {
        productsService.clearCache();
        if (!isSearchStarted) {
          ctrl.changeSearchParams();
          ctrl.searchStarted = true;
          ctrl.showSearchResult = false;
        }

        if (!ctrl.idTicket) {
          ctrl.searchProductParams = {
            searchFields: ctrl.searchFields || {},
            fundingWorksheets: ctrl.fundingWorksheets || {},
            maximumBorrowing: ctrl.maximumBorrowing || {}
          };
          const len = ctrl.searchProductParams?.maximumBorrowing?.contacts?.length || 0;
          for (let c = 0; c < len; c += 1) {
            const contact = ctrl.searchProductParams?.maximumBorrowing?.contacts[c];
            contact.liabilitiesProposed = financeService.prepareServicingProposedLiabilities({
              contacts: ctrl.searchProductParams?.maximumBorrowing?.contacts || [],
              product: {},
              searchFields: ctrl.searchFields || {},
              idContact: contact?.id || `applicant${_.add(c, 1)}`
            });
          }
        }

        financesService
          .homeLoanProductsSearch({
            idTicket: ctrl.idTicket || '',
            searchProductParams: ctrl.searchProductParams || {},
            offsetNo: ctrl.availableProducts?.length || 0
          })
          .then((data) => {
            if (data?.status) {
              const products = [];
              for (let p = 0; p < data?.products?.length; p += 1) {
                products.push(Product.Build(data?.products[p]));
              }
              ctrl.availableProducts = ctrl.availableProducts.concat(products);
              if (!isSearchStarted) {
                ctrl.products = [];
                ctrl.showSearchResult = true;
                ctrl.searchStarted = false;
                ctrl.showSearch = false;
              }
              ctrl.isLoadingFinished = products?.length === 100;
              ctrl.products = products;
            } else {
              ctrl.showSearchResult = true;
              ctrl.searchStarted = false;
              ctrl.showSearch = false;
            }
          });
      };

      ctrl.searchProducts = ($event) => {
        $event.stopPropagation();
        productsService.clearCache();
        if (ctrl.chosenProducts.length < 4 || ctrl.isSplitSearch) {
          ctrl.searchStart({ isSearchStarted: false });
        } else {
          $mdDialog
            .show({
              targetEvent: $event,
              locals: {
                searchFields: ctrl.searchFields
              },
              template: templateSearchWarning,
              controllerAs: '$ctrl',
              controller(searchFields) {
                const ctr = this;
                ctr.searchFields = searchFields;
                ctr.confirm = () => {
                  $mdDialog.hide(ctr.searchFields);
                };
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              ctrl.searchFields = result;
              ctrl.products = [];
              for (let i = 0; i < ctrl.chosenProducts.length; i += 1) {
                ctrl.chosenProducts[i].isSelected = false;
                ctrl.productAdded(ctrl.chosenProducts[i]);
              }
              ctrl.chosenProducts = [];
              ctrl.searchStart({ isSearchStarted: false });
            });
        }
      };

      ctrl.resetSearchProducts = () => {
        ctrl.searchFields = HomeLoanSearchProduct.Blank();
        ctrl.changeSearchParams();
        ctrl.saveSearchLoanProducts();
      };

      ctrl.productsSelected = (data) => {
        if (!_.isEmpty(data)) {
          if (ctrl.isSplitSearch && data.isSelected) {
            ctrl.onSelected({ data });
          }
          if (!ctrl.isSplitSearch) {
            if (data.isSelected) {
              ctrl.chosenProducts.push(data);
            } else {
              const idx = _.findIndex(ctrl.chosenProducts || [], (p) => p?.id === data?.id);
              if (idx > -1) {
                ctrl.chosenProducts.splice(idx, 1);
              }
            }
            ctrl.productAdded(data);
          }
        }
      };

      ctrl.removeProduct = (idSelectedProduct) => {
        const removedProduct = _.find(
          ctrl.chosenProducts || [],
          (p) => p?.id === idSelectedProduct
        );
        if (removedProduct) {
          removedProduct.isSelected = false;
          ctrl.productsSelected(removedProduct);
        }
      };

      ctrl.showSection = () => {
        ctrl.onShow({ section: 'reviewLoanProducts' });
      };

      ctrl.productAdded = (data) => {
        if (data && data.isSelected) {
          const [reviewProduct, compareProduct] = homeLoanService.addProductToCompare({
            selectedProduct: data
          });
          if (!_.isEmpty(reviewProduct) && !_.isEmpty(compareProduct)) {
            ctrl.reviewProducts.push(reviewProduct);
            ctrl.compareProducts.push(compareProduct);
          }
        } else if (data && !data.isSelected) {
          const rIdx = _.findIndex(
            ctrl.reviewProducts || [],
            (p) => p?.idLender === data?.lender[0]?.id
          );
          if (rIdx > -1) {
            ctrl.reviewProducts.splice(rIdx, 1);
          }
          const cIdx = _.findIndex(
            ctrl.compareProducts || [],
            (p) => p?.idLender === data?.lender[0]?.id
          );
          if (cIdx > -1) {
            ctrl.compareProducts.splice(cIdx, 1);
          }
        }
        ctrl.saveSearchLoanProducts();
      };

      ctrl.getLender = (idLender) => _.find(ctrl.lenders || [], (l) => l?.id === idLender);

      ctrl.getLenderDocument = (idLender) => {
        const doc = _.find(
          ctrl.documents || [],
          (d) => d?.lender[0]?.id === idLender && _.indexOf(d?.type, 'LOGO') > -1
        );
        return doc?.url || '';
      };

      ctrl.showError = () =>
        !ctrl?.searchFields?.idLenders?.length ||
        !ctrl?.searchFields?.loanAmount ||
        !ctrl?.searchFields?.loanTerm;

      ctrl.searchProductChanges = (action) => {
        if (!_.isEmpty(ctrl.searchFields)) {
          ctrl.isProcessing = true;
          switch (action) {
            case 'toggleLenders':
              if (ctrl.searchFields?.idLenders?.length) {
                ctrl.searchFields.idLenders = [];
              } else {
                for (let l = 0; l < ctrl.lenders.length; l += 1) {
                  ctrl.searchFields.idLenders.push(ctrl.lenders[l]?.id);
                }
              }
              break;
            case 'repaymentType':
              if (ctrl.searchFields?.repaymentType === 'PI') {
                ctrl.searchFields.interestOnlyTerm = 0;
              }
              break;
            case 'rateType':
              if (ctrl.searchFields?.rateType !== 'FIXED') {
                ctrl.searchFields.fixedTerm = 0;
              }
              break;
            default:
              break;
          }
          ctrl.sPChanges();
        }
      };

      ctrl.sPChanges = _.debounce(() => {
        if (!_.isEmpty(ctrl.searchFields)) {
          ctrl.showSearchResult = false;
          ctrl.changeSearchParams();
          ctrl.saveSearchLoanProducts();
        }
      }, 3000);

      ctrl.saveSearchLoanProducts = () => {
        const data = {
          reviewProducts: ctrl.reviewProducts,
          compareProducts: ctrl.compareProducts,
          searchFields: ctrl.searchFields,
          hLCD: 'homeLoanSearchProducts'
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'homeLoanSearchProducts') {
          ctrl.isProcessing = false;
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
